var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLikeRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.315 37.9523C20.5392 38.13 20.8148 38.2269 21.0986 38.2278C21.3825 38.2269 21.6581 38.13 21.8823 37.9523C29.0252 32.286 33.9455 27.4066 37.3885 22.5929C41.7822 16.4412 42.7842 10.7618 40.369 5.71189C38.6475 2.10485 33.6886 -0.820138 27.9203 0.871894C25.164 1.68478 22.7591 3.42802 21.0986 5.81683C19.4382 3.42802 17.0333 1.68478 14.2769 0.871894C8.49581 -0.846371 3.54975 2.10485 1.82826 5.71189C-0.586961 10.7618 0.415099 16.4412 4.80874 22.5929C8.25172 27.4066 13.1721 32.286 20.315 37.9523Z",
    fill: "#EA1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLikeRed);
export default __webpack_public_path__ + "static/media/IconLikeRed.3dd818bb9fd4052293cc4169fd23cc6a.svg";
export { ForwardRef as ReactComponent };